import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../utils/firebaseConfig";
import BotonCarrito from "../components/BotonCarrito";
import { FiPhone } from "react-icons/fi";
import { toast } from "react-toastify";
import { useCarrito } from "../context/CarritoContext";
import { Link } from "react-router-dom";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/styles.min.css";
import CarruselProductos from "../components/CarruselProductos";

const getCategoriaBonita = (categoria) => {
  const key = categoria?.toLowerCase().trim();
  if (key === "kimberly clark") return "Paños de limpieza";
  return categoria;
};

export default function ProductDetail() {
  const { sku } = useParams();
  const [producto, setProducto] = useState(null);
  const [mostrarControles, setMostrarControles] = useState(false);
  const [cantidad, setCantidad] = useState(1);
  const [modoVenta, setModoVenta] = useState("individual");
  const { agregarAlCarrito } = useCarrito();
  const [vistosRecientemente, setVistosRecientemente] = useState([]);
  const [recomendados, setRecomendados] = useState([]);

  useEffect(() => {
    if (producto?.modoFardo) {
      setModoVenta("individual");
    }
  }, [producto]);
  
  useEffect(() => {
    setProducto(null); // <- esto es clave
    const productos = JSON.parse(localStorage.getItem("productos") || "[]");
    const encontrado = productos.find((p) => p.sku === sku);
  
    if (encontrado) {
      setProducto(encontrado);
  
      // Recomendados de la misma categoría (excepto el actual)
      const mismaCategoria = productos.filter(
        (p) => p.categoria === encontrado.categoria && p.nombre !== encontrado.nombre
      );
      const aleatorios = mismaCategoria.sort(() => 0.5 - Math.random()).slice(0, 10);
      setRecomendados(aleatorios);
    }
  
    // Recién vistos
    const vistos = JSON.parse(localStorage.getItem("vistos") || "[]");
    setVistosRecientemente(vistos);
  }, [sku]);
    
  useEffect(() => {
    const cantidadGuardada = localStorage.getItem("cantidadProducto");
    if (cantidadGuardada) {
      setCantidad(parseInt(cantidadGuardada));
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (producto) {
      const vistos = JSON.parse(localStorage.getItem("vistos") || "[]");
      const yaExiste = vistos.find((p) => p.sku === producto.sku);
      const nuevosVistos = yaExiste
        ? vistos.filter((p) => p.sku !== producto.sku)
        : vistos;
      localStorage.setItem("vistos", JSON.stringify([producto, ...nuevosVistos].slice(0, 10)));
    }
  }, [producto]);

  if (!producto) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <p className="text-center text-gray-500">Cargando producto...</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-100 min-h-screen flex flex-col items-center justify-start py-10 px-4 space-y-10">
      <div className="w-full max-w-4xl mb-4 text-sm text-gray-600">
        <Link to="/" className="text-sky-600 hover:underline">
          Inicio
        </Link>
        {producto.categoria && (
          <>
            <span className="mx-2 text-gray-400">/</span>
            <Link
              to={`/catalogo?categoria=${encodeURIComponent(producto.categoria)}`}
              className="text-sky-600 hover:underline capitalize"
            >
              {getCategoriaBonita(producto.categoria)}
            </Link>
          </>
        )}
        <span className="mx-2 text-gray-400">/</span>
        <span className="text-gray-800 font-medium">{producto.nombre}</span>
      </div>
      <div className="w-full max-w-4xl bg-white shadow-md rounded-lg p-6">
        <div className="grid md:grid-cols-2 gap-6 items-center">
          {/* Imagen con efecto zoom */}
          <div className="overflow-hidden rounded-lg border">
            <div className="flex justify-center items-center bg-white p-4 rounded-lg">
              <InnerImageZoom
                src={producto.imagen}
                zoomSrc={producto.imagen}
                zoomType="hover"
                zoomPreload={true}
                alt={producto.nombre}
                className="rounded-lg w-full max-w-[400px] mx-auto"
              />
            </div>
          </div>

          {/* Detalles del producto */}
          <div
            onMouseMove={(e) => {
              const box = e.currentTarget.getBoundingClientRect();
              const centerX = box.left + box.width / 2;
              const rotateY = (e.clientX - centerX) / 25;
              e.currentTarget.style.transform = `perspective(600px) rotateY(${rotateY}deg)`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "perspective(600px) rotateY(0deg)";
            }}
            className="transition-transform duration-300 will-change-transform bg-white p-6 rounded-xl shadow-xl"
          >
            <h2 className="text-3xl font-bold text-[#40767b] mb-2">{producto.nombre}</h2>
            <p className="text-gray-600 mb-4">
              {producto.descripcion || "Sin descripción detallada."}
            </p>

            {producto.modoFardo && (
              <div className="mb-4">
                <button
                  onClick={() => setModoVenta((prev) => (prev === "individual" ? "fardo" : "individual"))}
                  className="text-sm text-sky-600 underline hover:text-sky-800 transition"
                >
                  Cambiar a {modoVenta === "individual" ? "fardo" : "individual"}
                </button>
                <p className="text-xs text-gray-500 mt-1">Modo actual: <strong>{modoVenta}</strong></p>
              </div>
            )}

          
            {/* Agregar al carrito */}
            {!mostrarControles ? (
              <button
                onClick={() => setMostrarControles(true)}
                className="w-full mt-6 mb-4 px-6 py-3 flex items-center justify-center rounded-full text-lg font-medium transition-shadow duration-200 bg-white text-[#40767b] ring-1 ring-[#b5d2d5] hover:bg-[#f4fbfc] hover:text-[#2d4f51] hover:ring-[#90bfc4] shadow-sm hover:shadow-lg"
              >
                Cotizar
              </button>
            ) : (
              <div className="flex items-center flex-wrap gap-4 mt-4">
                {/* Botón - */}
                <button
                  onClick={() => setCantidad((prev) => Math.max(prev - 1, 1))}
                  className="w-10 h-10 flex items-center justify-center rounded-full text-xl font-semibold bg-white text-sky-700 ring-1 ring-sky-200 hover:bg-sky-50 hover:text-sky-900 hover:ring-sky-300 shadow-sm hover:shadow-lg"
                >
                  −
                </button>
          
                {/* Cantidad */}
                <input
                  type="number"
                  value={cantidad}
                  onChange={(e) => {
                    const nuevaCantidad = parseInt(e.target.value);
                    if (!isNaN(nuevaCantidad) && nuevaCantidad >= 1) {
                      setCantidad(nuevaCantidad);
                    }
                  }}
                  className="w-16 text-center text-lg font-bold text-[#40767b] border border-gray-300 rounded-md px-2 py-1"
                />
          
                {/* Botón + */}
                <button
                  onClick={() => setCantidad((prev) => prev + 1)}
                  className="w-10 h-10 flex items-center justify-center rounded-full text-xl font-semibold bg-white text-sky-700 ring-1 ring-sky-200 hover:bg-sky-50 hover:text-sky-900 hover:ring-sky-300 shadow-sm hover:shadow-lg"
                >
                  +
                </button>
          
                {/* Confirmar */}
                <button
                  onClick={() => {
                    const productoParaCarrito = {
                      sku: producto.sku,
                      nombre: producto.nombre,
                      descripcion: producto.descripcion,
                      imagen: producto.imagen,
                      cantidad: cantidad,
                      modoVenta: producto.modoFardo ? modoVenta : null,
                      modoFardo: !!producto.modoFardo
                    };
                    
                    // Limpia cualquier propiedad no deseada
                    const productoLimpio = Object.fromEntries(
                      Object.entries(productoParaCarrito).filter(([key]) => 
                        key !== 'precio' && key !== 'stock'
                      )
                    );
                    
                    agregarAlCarrito(productoLimpio);
                    toast.success("Producto agregado al carrito");
                    setMostrarControles(false);
                    setCantidad(1);
                    localStorage.removeItem("cantidadProducto");
                  }}
                  className="relative ml-4 px-6 py-2 rounded-full text-sm font-semibold text-white bg-gradient-to-br from-[#6dbbb2] to-[#40767b] shadow-lg hover:shadow-xl transition-shadow duration-200"
                >
                  Confirmar
                </button>
          
                {/* Cancelar */}
                <button
                  onClick={() => {
                    setMostrarControles(false);
                    setCantidad(1);
                    localStorage.removeItem("cantidadProducto");
                  }}
                  className="px-4 py-2 rounded-full text-sm font-medium text-gray-500 ring-1 ring-gray-300 hover:bg-gray-50 hover:text-gray-700 hover:ring-gray-400 transition-shadow duration-200"
                >
                  Cancelar
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Sección de contacto */}
      <div className="w-full max-w-4xl bg-white shadow-md rounded-lg p-6">
        <h3 className="text-xl font-bold text-[#40767b] mb-2">¿Tienes preguntas?</h3>
        <p className="text-gray-600 mb-4">
          Contáctanos por WhatsApp y con gusto resolveremos tus dudas sobre este producto.
        </p>
        <a
          href={`https://wa.me/50255106042?text=Hola, estoy interesado en el producto: ${encodeURIComponent(producto.nombre)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-lg shadow hover:bg-green-600 transition duration-300"
        >
          <FiPhone /> Escribir por WhatsApp
        </a>
      </div>

      {/* Recomendados */}
      {recomendados.length > 0 && (
        <div className="w-full max-w-4xl">
          <h2 className="text-xl font-bold text-[#40767b] mt-8 mb-4">Te puede interesar</h2>
          <CarruselProductos productos={recomendados} />
        </div>
      )}
      
      {/* Recién vistos */}
      {vistosRecientemente.length > 0 && (
        <div className="w-full max-w-4xl">
          <h2 className="text-xl font-bold text-[#40767b] mt-8 mb-4">Vistos recientemente</h2>
          <CarruselProductos productos={vistosRecientemente} />
        </div>
      )}

      {/* Botón del carrito siempre visible */}
      {/*<BotonCarrito />*/}
    </div>
  );
}

